import { jsx as _jsx } from "react/jsx-runtime";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { clearIdAndTokenInLS } from "../core/token.js";
import { createContext, useCallback, useState } from 'react';
export const queryContext = createContext(undefined);
export const queryClient = new QueryClient();
export const FractalSDKContext = createContext({
    clientId: '',
    resetUser: () => undefined,
    setUser: () => undefined,
    setUserWallet: () => undefined,
    user: undefined,
    userWallet: undefined,
});
export function FractalSDKContextProvider({ children, clientId, }) {
    const [user, setUser] = useState(undefined);
    const [userWallet, setUserWallet] = useState(undefined);
    const resetUser = useCallback(() => {
        clearIdAndTokenInLS();
        setUser(undefined);
        setUserWallet(undefined);
    }, []);
    return (_jsx(FractalSDKContext.Provider, { value: {
            clientId,
            resetUser,
            setUser,
            setUserWallet,
            user,
            userWallet,
        }, children: _jsx(QueryClientProvider, { client: queryClient, context: queryContext, children: children }) }));
}
//# sourceMappingURL=fractal-sdk-context.js.map